import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { UAParser } from 'ua-parser-js';

// Components
import Portal from './components/Portal/Portal.jsx';
import GlobalLoader from './components/GlobalLoader/GlobalLoader.jsx';

// Hooks
import { useAppDispatch, useAppSelector } from './store';

// Routes
import { router } from './routes';

// Action
import { setIsIOS, setMobile, setTablet } from './store/slices/mainSlice.js';

// Styles
import styleVariables from './styles/variables/exportedVars.module.scss';
import './styles/reset.scss';

const App = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(s => s.main.loader.isLoading);

  useEffect(() => {
    const userAgent = UAParser(window.navigator.userAgent);
    const isIOS = userAgent?.os.name === 'iOS';
    dispatch(setIsIOS(isIOS));
  }, [dispatch]);

  useEffect(() => {
    const mobileMediaQuery = `(max-width: ${styleVariables.phoneWidth})`;
    const tabletMediaQuery = `(max-width: ${styleVariables.tabletWidth})`;
    const mediaQueryList = window.matchMedia(mobileMediaQuery);
    const tabletQueryList = window.matchMedia(tabletMediaQuery);

    const handleChange = () => {
      dispatch(setMobile(mediaQueryList.matches));
      dispatch(setTablet(tabletQueryList.matches));
    };

    handleChange();

    try {
      // Chrome, Firefox etc.
      mediaQueryList.addEventListener('change', handleChange);
      tabletQueryList.addEventListener('change', handleChange);

      return () => {
        mediaQueryList.removeEventListener('change', handleChange);
        tabletQueryList.removeEventListener('change', handleChange);
      };
    } catch (e1) {
      try {
        // Safari
        mediaQueryList.addListener(handleChange);
        tabletQueryList.addListener(handleChange);

        return () => {
          mediaQueryList.removeListener(handleChange);
          tabletQueryList.removeListener(handleChange);
        };
      } catch (e) {
        console.error(e);
      }
    }
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Wix+Madefor+Display:wght@400;500;600;700;800&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;900&display=swap"
          rel="stylesheet"
        />
        <meta name="theme-color" content="#000000" />
        <meta name="description" content="Tribe perpetual" />
        <title>Tribe perpetual</title>
      </Helmet>
      <RouterProvider router={router} />
      {isLoading && (
        <Portal>
          <GlobalLoader />
        </Portal>
      )}
    </>
  );
};

export default App;
